import React, { useEffect, useContext } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import NavbarComp1 from "../components/Navbar1";
import loginImg from "../images/audio-description.png";
import isl2dImg from "../images/2D-ISL.png";
import isllivetranscriptImg from "../images/live-transcript.png";
import isl3dImg from "../images/3D-ISL.png";
import Footer from "../components/Footer";

import { UserContext } from "../jsx/UserContext";
import "../css/main.css";

function Dashboard() {
  
  const { userSession } = useContext(UserContext);
  const navigate = useNavigate();
console.log("userSession in isldashobard",userSession)
  const storedUserSession = JSON.parse(localStorage.getItem("userSession"));

  // useEffect(() => {
  //   if (!userSession?.name) {
  //     navigate("/login");
  //   }
  // }, [userSession, navigate]);
useEffect(() => {
  const storedSession = JSON.parse(localStorage.getItem("userSession"));

  if (!storedSession?.access_token || Date.now() > storedSession.expiresAt) {
    localStorage.removeItem("userSession");
    navigate("/login", { replace: true });
  }
}, []);

  return (
<div class="main-div">
  {/* Skip to main content link */}
  <a
    href="#main-content"
    className="visually-hidden-focusable"
    style={{
      position: "absolute",
      top: "-40px",
      left: "0",
      background: "#000",
      color: "#fff",
      padding: "8px 16px",
      zIndex: "1000",
      borderRadius: "4px",
    }}
    onFocus={(e) => (e.target.style.top = "0")}
    onBlur={(e) => (e.target.style.top = "-40px")}
  >
    Skip to main content
  </a>

  <NavbarComp1 />

  <Container
    id="main-content"
    role="main"
    aria-label="Dashboard content"
  >
     <h1 id="dashboardHeading" className="visually-hidden">
        Dashboard
      </h1>
    <Row className="justify-content-center g-4">
   

      {/* ISL 2d Video Card */}
      {/* <Col xs={12} sm={6} md={5} lg={4}> */}
      <Col xs={12} sm={4} md={5} lg={4}>

        <Card
          className="dashboard-card"
          tabIndex={0}
          role="button"
          aria-label="Open ISL 2D video generator "
          aria-describedby="isl 2D VideoCard"
          onClick={() => navigate("/Islvideo")}
          onKeyDown={(e) => e.key === "Enter" && navigate("/Islvideo")}
        >
          <Card.Img
            variant="top"
            src={isl2dImg}
            alt="Indian Sign Language 2D video generation"
          />
          <Card.Body className="dashboard-carddiv bg-dark1 text-white text-center">
            <Card.Title className="fw-bold">ISL Translator </Card.Title>
            <span id="isl 2D VideoCard" className="visually-hidden">
                Press Enter to open the ISL 2D video generation page.
            </span>
          </Card.Body>
        </Card>
      </Col>


{storedUserSession?.custom_data !== 'tiles' && (
<>


 <Col xs={12} sm={4} md={5} lg={4}>

       

        <Card
  className="dashboard-card"
  tabIndex={0}
  role="button"
  aria-label="Open ISL 3D video generation page"
  aria-describedby="isl 3D VideoCard"
  // onClick={() => window.open("https://genislai.amritacreate.org/", "_blank")} 
    onClick={() => window.open("https://isl.chalachitravaachana.org/", "_blank")} 

  onKeyDown={(e) =>
    e.key === "Enter" && window.open("https://isl.chalachitravaachana.org/", "_blank")
  }
>

          <Card.Img
            variant="top"
            src={isl3dImg}
              alt="Indian Sign Language 3D avatar video generation"
          />
          <Card.Body className=" dashboard-carddiv bg-dark1 text-white text-center">
            <Card.Title className="fw-bold"> ISL Translator (Realtime Beta)</Card.Title>
            <span id="isl 3D VideoCard" className="visually-hidden">
                Press Enter to open the ISL 3D video generation page.
            </span>
          </Card.Body>
        </Card>
      </Col>
{/* 
 <Col xs={12} sm={4} md={5} lg={4}>

        <Card
          className="dashboard-card"
          tabIndex={0}
          role="button"
          aria-label="Open ISL Live Transcription"
          aria-describedby="isl Live Transcription VideoCard"
          onClick={() => navigate("/IslLive")}
          onKeyDown={(e) => e.key === "Enter" && navigate("/IslLive")}
        >
          <Card.Img
            variant="top"
            src={isllivetranscriptImg}
            alt="Indian Sign Language Live Transcription"
          />
          <Card.Body className="dashboard-carddiv bg-dark1 text-white text-center">
            <Card.Title className="fw-bold">ISL Live Transcription </Card.Title>
            <span id="isl Live Transcription VideoCard" className="visually-hidden">
                Press Enter to open the ISL Live Transcription page.
            </span>
          </Card.Body>
        </Card>
      </Col> */}

</>
)}


    </Row>
    
  </Container>
  <Footer />
  
</div>



    // <div role="main" aria-label="Dashboard Page">
    //   <NavbarComp1 />

    //   <Container style={{ marginTop: "30px" }} aria-label="Dashboard content">
    //     <Row className="justify-content-center g-4">
    //       <Col xs={12} sm={6} md={5} lg={4}>
    //         <Card
    //           className="dashboard-card"
    //           tabIndex={0}
    //           role="button"
    //           aria-label="Audio Description: Click to go to Audio Description page"
    //           onClick={() => navigate("/Fileupload")}
    //           onKeyDown={(e) => e.key === "Enter" && navigate("/Fileupload")}
    //         >
    //           <Card.Img
    //             variant="top"
    //             src={loginImg}
    //             alt="Audio description page illustration"
    //           />
    //           <Card.Body className="bg-dark text-white text-center">
    //             <Card.Title className="fw-bold">
    //               Audio Description
    //             </Card.Title>
    //           </Card.Body>
    //         </Card>
    //       </Col>
    //       <Col xs={12} sm={6} md={5} lg={4}>
    //         <Card
    //           className="dashboard-card"
    //           tabIndex={0}
    //           role="button"
    //           aria-label="ISL Video: Click to go to ISL Video page"
    //           onClick={() => navigate("/Islvideo")}
    //           onKeyDown={(e) => e.key === "Enter" && navigate("/Islvideo")}
    //         >
    //           <Card.Img
    //             variant="top"
    //             src={audioconverterImg}
    //             alt="Indian Sign Language video page illustration"
    //           />
    //           <Card.Body className="bg-dark text-white text-center">
    //             <Card.Title className="fw-bold">
    //               ISL Video
    //             </Card.Title>
    //           </Card.Body>
    //         </Card>
    //       </Col>
    //     </Row>
    //   </Container>
    // </div>

  );
}

export default Dashboard;
